import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useOrdinalFormatter } from "../../../hooks/useOrdinalFormatter";
import { useDateTimeFormatter } from "../../../hooks/useDateTimeFormatter";
import { BalanceUpdateTournamentAwardContentFragmentFragment } from "../../../graphql/ActivityFragment.generated";

export const BalanceUpdateTournamentAwardActivity = ({
  content,
}: {
  content: BalanceUpdateTournamentAwardContentFragmentFragment;
}) => {
  const ordinalFormatter = useOrdinalFormatter();
  const dateTimeFormatter = useDateTimeFormatter();
  const { t } = useTranslation();
  return (
    <Trans i18nKey="notification.balance_update_tournament_award_activity">
      You have finished{" "}
      <strong>{{ position: ordinalFormatter.format(content.position) }}</strong>{" "}
      on tournament <strong>{{ tournament: content.tournament.name }}</strong>{" "}
      for game{" "}
      <strong>{{ game: t(`game.${content.tournament.section.type}`) }}</strong>{" "}
      that ended on{" "}
      <strong>
        {{ end: dateTimeFormatter.format(new Date(content.tournament.end)) }}
      </strong>
    </Trans>
  );
};
